import { createContext } from "react";
export var MenuContext = createContext({
    linkComponent: "a"
});
